var FNTGeneratorBase = /** @class */ (function () {
    function FNTGeneratorBase(_stage) {
        this._stage = _stage;
    }
    return FNTGeneratorBase;
}());
export { FNTGeneratorBase };
